"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENVIRONMENT_CODES = void 0;
const ENVIRONMENT_CODES = exports.ENVIRONMENT_CODES = {
  DEV: 'dev',
  UAT: 'uat',
  STG: 'stg',
  LIVE: 'live'
};
//# sourceMappingURL=enviromentCodes.js.map